import { WifiOff } from "lucide-react";

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";

interface EstadoSinConexionProps {
  /** Qué no se pudo pedir, en palabras del dominio ("los perfiles"). */
  que: string;
}

/**
 * Sin conexión, la petición queda PAUSADA — no fallida.
 *
 * Ese tercer estado es el que hacía mentir a las pantallas: no está cargando,
 * no hay error y no hay datos, así que ganaba la rama del vacío y el listado
 * afirmaba "todavía no hay perfiles" con tres perfiles vivos en el backend.
 *
 * No lleva botón de reintento a propósito: TanStack Query reanuda sola la
 * petición pausada apenas vuelve la red, y ofrecer un botón que no puede
 * hacer nada es otra forma de mentir.
 */
export function EstadoSinConexion({ que }: EstadoSinConexionProps) {
  return (
    <Empty className="rounded-xl border">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <WifiOff />
        </EmptyMedia>
        <EmptyTitle>Sin conexión</EmptyTitle>
        <EmptyDescription>
          No pudimos pedir {que} porque el equipo está sin red. La pantalla se completa
          sola apenas vuelva la conexión.
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
